import React, { useEffect } from 'react'
import EmbroideryPage from './EmbroideryPage'
import '../styles/index.scss'
import queryString from 'query-string'

function EmbroideryContainer(props) {
    const query = queryString.parse(props.location.search)
    const template = query.template || ''
    const partnerCode = query.partnerCode || ''

    useEffect(() => {
        const timer = setTimeout(() => {
            const url = new URL(window.location.href)
            url.search = ""
            window.history.replaceState({}, document.title, url.pathname)
        }, 0)

        return () => clearTimeout(timer)
    }, [])
 
    return (
        <div className='EmbroideryContainer px-5 pt-3 pb-5'>
            <div className='row'>
                <div className='col-12 mx-auto'>
                    <div className="d-flex align-items-baseline justify-content-between">
                        <h1 className="PageTitle">Thông tin thêu</h1>
                    </div>
                    <div className="site-layout-background">
                        <EmbroideryPage 
                            currentTemplate={template}  
                            partnerCode={partnerCode}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmbroideryContainer